export const customersDraftUrl = '/crm/customers/draft/';

export default { customersDraftUrl };
